import {ShoppingPathJointReportReasonIO} from "../../../../io/content/ShoppingPathJointReportReasonIO";
import {
    ShoppingPathJointReportReasonValueObject
} from "../../../../model/vo/content/ShoppingPathJointReportReasonValueObject";
import {
    ShoppingPathJointReportReasonDataTransferObject
} from "../../../../model/dto/content/ShoppingPathJointReportReasonDataTransferObject";
import {Column, Row} from "../../common/Layout";
import {RouteContext} from "../../../RouteContext";
import {useParams} from "react-router-dom";
import {
    InputStringStatePair,
    StatePair,
    useError,
    useInputString,
    useStatePair,
    useUndefined
} from "../../../../type/States";
import {useEffect} from "react";
import {Button, Field, FieldProps, Input, Spinner} from "@fluentui/react-components";
import {Styles} from "../../common/Styles";
import {DataTransferObjectValidation, Types} from "../../../../type/Types";

export default function Edit(props: RouteContext) {
    const params = useParams<{ id: string }>()
    const itemState = useUndefined<ShoppingPathJointReportReasonValueObject>()
    const itemErrorState = useError()

    useEffect(() => {
        if (params.id === undefined) {
            return
        }
        if (itemState.value !== undefined) {
            return
        }

        ShoppingPathJointReportReasonIO.get(BigInt(params.id))
            .then(itemState.setDefinedValue)
            .catch(itemErrorState.setDefinedValue)
    }, [params.id, itemState.value])

    const item = itemState.value
    return <>
        <itemErrorState.Dialog {...props} />
        {item === undefined && <Spinner />}
        {item !== undefined && <>
            <EditPage
                {...props}
                item={item}></EditPage>
        </>}
    </>
}

type EditPageProps = RouteContext & {
    item: ShoppingPathJointReportReasonValueObject
}

function EditPage(props: EditPageProps) {
    const styles = Styles.useEditorStyles()
    const inputStates: Record<keyof ShoppingPathJointReportReasonDataTransferObject.Put, InputStringStatePair> = {
        body: useInputString(Types.present(props.item.body, '')),
    }
    const inputValidationStates: Record<keyof ShoppingPathJointReportReasonDataTransferObject.Put, StatePair<FieldProps['validationState']>> = {
        body: useStatePair<FieldProps['validationState']>('none'),
    }
    const putErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.body.setValue('none')
        try {
            const dto: ShoppingPathJointReportReasonDataTransferObject.Put = {
                body: DataTransferObjectValidation.validate(ShoppingPathJointReportReasonDataTransferObject.Put.validation, 'body', inputStates.body.value, () => inputValidationStates.body.setValue('error')),
            }

            ShoppingPathJointReportReasonIO.put(props.item.id, dto)
                .then(() => window.alert('추가되었습니다.'))
                .catch(putErrorState.setDefinedValue)
        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <putErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={ShoppingPathJointReportReasonDataTransferObject.Put.description.body}
                validationState={inputValidationStates.body.value}>
                <Input
                    value={inputStates.body.value}
                    onChange={inputStates.body.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}